import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import { AdminProvider } from './contexts/AdminContext';
import { StaffProvider } from './contexts/StaffContext';
import { LanguageProvider } from './contexts/LanguageContext';
import UserHeader from './components/UserHeader';
import SelectCourtType from './components/SelectCourtType';
import CourtDetails from './components/CourtDetails';
import Receipt from './components/Receipt';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentFailed from './components/PaymentFailed';
import AdminDashboard from './components/admin/AdminDashboard';
import StaffDashboard from './components/StaffDashboard';
import DevUserSwitcher from './components/DevUserSwitcher';

function App() {
  return (
    <LanguageProvider>
      <UserProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Admin Routes - wrapped with AdminProvider */}
              <Route path="/admin/*" element={
                <AdminProvider>
                  <AdminDashboard />
                </AdminProvider>
              } />
              
              {/* Staff Routes */}
              <Route path="/staff" element={
                <StaffProvider>
                  <StaffDashboard />
                </StaffProvider>
              } />
              
              {/* User Routes */}
              <Route path="/" element={
                <>
                  <UserHeader />
                  <SelectCourtType />
                </>
              } />
              <Route path="/court-details/:courtTypeId" element={
                <>
                  <UserHeader />
                  <CourtDetails />
                </>
              } />
              {/* <Route path="/payment/:paymentId" element={
                <>
                  <UserHeader />
                  <Payment />
                </>
              } /> */}
              <Route path="/receipt/:paymentId" element={
                <>
                  <UserHeader />
                  <Receipt />
                </>
              } />
              <Route path="/payment/success/:paymentId" element={
                <>
                  <UserHeader />
                  <PaymentSuccess />
                </>
              } />
              <Route path="/payment/failed/:paymentId" element={
                <>
                  <UserHeader />
                  <PaymentFailed />
                </>
              } />
            </Routes>
            <DevUserSwitcher />
          </div>
        </Router>
      </UserProvider>
    </LanguageProvider>
  );
}

export default App;
